import React, { useState } from "react";
import Box from "@mui/material/Box";
import FilterComponent from "../../../../../../../ReusableFIlterComponent/FilterComponent";

interface loadedAccordionsFilterProps {
  data: any;
  setSelectedAdGroup: any;
  setSelectedCampaign: any;
  setSelectedMatchType: any;
  setSelectedTrafficSource: any;
  selectedTrafficSource: any;
  selectedMatchType: any;
  selectedCampaign: any;
  selectedAdGroup: any;
}

const FilterLoadedAccordions: React.FC<loadedAccordionsFilterProps> =
  React.memo(
    ({
      data,
      setSelectedAdGroup,
      setSelectedCampaign,
      setSelectedMatchType,
      setSelectedTrafficSource,
      selectedTrafficSource,
      selectedMatchType,
      selectedCampaign,
      selectedAdGroup,
    }: loadedAccordionsFilterProps) => {
      const queryOutputs = data;

      const [searchTrafficSource, setSearchTrafficSource] = useState("");
      const [searchMatchType, setSearchMatchType] = useState("");
      const [searchCampaign, setSearchCampaign] = useState("");
      const [searchAdGroup, setSearchAdGroup] = useState("");

      const filterConfig = [
        {
          key: "Traffic Source",
          label: "Select Traffic Source",
          searchTerm: searchTrafficSource,
          onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchTrafficSource(e.target.value),
          selectedOption: selectedTrafficSource,
          filterName: "traffic_source",
          data: queryOutputs,
          onSelectionChange: (updatedSelection: any) =>
            setSelectedTrafficSource(updatedSelection),
          count: selectedTrafficSource && selectedTrafficSource.length,
          colorSelected:
            selectedTrafficSource !== null && selectedTrafficSource.length > 0
              ? "#9C27B0"
              : "#000000DE",
          multiSelect: true,
          showSearch: true,
        },
        {
          key: "Match Type",
          label: "Select Match Type",
          searchTerm: searchMatchType,
          onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchMatchType(e.target.value),
          selectedOption: selectedMatchType,
          filterName: "matchtype",
          data: queryOutputs,
          onSelectionChange: (updatedSelection: any) =>
            setSelectedMatchType(updatedSelection),
          count: selectedMatchType && selectedMatchType.length,
          colorSelected:
            selectedMatchType !== null && selectedMatchType.length > 0
              ? "#9C27B0"
              : "#000000DE",
          multiSelect: true,
          showSearch: true,
        },
        {
          key: "Campaign",
          label: "Select Campaign",
          searchTerm: searchCampaign,
          onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchCampaign(e.target.value),
          selectedOption: selectedCampaign,
          filterName: "campaign_name",
          data: queryOutputs,
          onSelectionChange: (updatedSelection: any) =>
            setSelectedCampaign(updatedSelection),
          count: selectedCampaign && selectedCampaign.length,
          colorSelected:
            selectedCampaign !== null && selectedCampaign.length > 0
              ? "#9C27B0"
              : "#000000DE",
          multiSelect: true,
          showSearch: true,
        },
        {
          key: "AdGroup",
          label: "Select AdGroup",
          searchTerm: searchAdGroup,
          onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchAdGroup(e.target.value),
          selectedOption: selectedAdGroup,
          filterName: "adgroup_name",
          data: queryOutputs,
          onSelectionChange: (updatedSelection: any) =>
            setSelectedAdGroup(updatedSelection),
          count: selectedAdGroup && selectedAdGroup.length,
          colorSelected:
            selectedAdGroup !== null && selectedAdGroup.length > 0
              ? "#9C27B0"
              : "#000000DE",
          multiSelect: true,
          showSearch: true,
        },
      ];

      const clearFilters = () => {
        setSelectedTrafficSource([]);
        setSelectedMatchType([]);
        setSelectedCampaign([]);
        setSelectedAdGroup([]);
      };

      return (
        <Box key={"1"}>
          <FilterComponent
            filterConfig={filterConfig}
            clearFilters={clearFilters}
          />
        </Box>
      );
    }
  );

export default FilterLoadedAccordions;
